// LinkedIn "Open to..." cards as exposed via Crustdata's
// ``open_to_cards`` array filter.
//
// Probe-verified canonical wire values are uppercase identifiers:
// CAREER_INTEREST, HIRING_MANAGER, VOLUNTEERING. The UI uses friendly
// labels and translates back to canonical when submitting.

export interface OpenToCardOption {
  /** Canonical Crustdata wire value. */
  value: string;
  /** UI display label. */
  label: string;
  /** One-line tooltip describing what this signal means. */
  description: string;
}

export const OPEN_TO_CARD_OPTIONS: OpenToCardOption[] = [
  {
    value: 'CAREER_INTEREST',
    label: 'Open to opportunities',
    description: 'Profile has the "Open to Work" career-interest card visible.',
  },
  {
    value: 'HIRING_MANAGER',
    label: 'Hiring',
    description:
      'Profile has the "Hiring" card — actively recruiting for their team.',
  },
  {
    value: 'VOLUNTEERING',
    label: 'Open to volunteering',
    description: 'Profile signals interest in volunteer or board roles.',
  },
];
